import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogContentText, Grid, Toolbar, Typography } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';

export const FormVincularProdutoPerfil = () => {

  return (
    <Dialog
      open={true}
      fullScreen
      scroll={'paper'}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth
      maxWidth={"lg"}
      PaperProps={{
        component: 'form',
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
        },
      }}
    >
        <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <Typography sx={{ ml: 2, flex: 1 }} textTransform={"uppercase"} fontWeight={"bold"} variant="h6" component="div">
            Vincular Produtos ao Perfil
          </Typography>
          <Button
            color="inherit"
            startIcon={<>
              <CloseIcon />
            </>}
            aria-label="close"
          >
            Fechar
          </Button>
        </Toolbar>
      </AppBar>
      <DialogContent dividers={true}>
        <DialogContentText id="scroll-dialog-description" tabIndex={-1}></DialogContentText>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container>

              {/* {perfilAVincularProduto?.produtos.map((produto) => (
                <Grid item xs={12} key={produto.produtoId}>
                  <Accordion sx={{

                  }} expanded={
                    produto.status
                  }>
                    <AccordionSummary sx={{
                      background: produto.status ? theme.palette.primary.main : undefined,
                      color: produto.status ? theme.palette.primary.contrastText : undefined
                    }} >
                      <Grid container spacing={3} alignItems={"center"}>
                        <Grid item>
                          <Checkbox color="secondary" onChange={(e) => {
                            togglePerfilAVincularProduto({
                              produtoId: produto.produtoId
                            })
                          }} checked={
                            produto.status
                          } />
                        </Grid>
                        <Grid item>
                          <Typography>{produto.produto}</Typography>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    {
                      produto.status && <AccordionDetails>
                        <Grid container>
                          <Grid item xs={12}>
                            <TextField
                              color="primary"
                              variant="outlined"
                              label="Quantidade Consumo"
                              fullWidth
                              value={
                                produto.limit.toLocaleString()
                              }
                              onChange={(e) => {
                                let value: string | number = e.target.value
                                // cast to number
                                value = value.replace(/\D/g, '')
                                value = Number(value)
                                if (isNaN(value)) {
                                  value = 0
                                }
                                setProdutoVinculadoLimit({
                                  produtoId: produto.produtoId,
                                  limit: value
                                })
                              }}
                            />
                          </Grid>
                          {produto.consumos.map((consumo) => {
                            return <Grid item xs={12} key={`${produto.produtoId}- ${consumo.tipoConsumoId}`}>
                              <FormControlLabel control={<Switch checked={
                                consumo.status
                              } onChange={(e) => {
                                togglePerfilAVincularProdutoConsumo({
                                  produtoId: produto.produtoId,
                                  consumoId: consumo.tipoConsumoId
                                })
                              }} />} label={consumo.nome} />

                            </Grid>
                          })}
                        </Grid>
                      </AccordionDetails>
                    }

                  </Accordion>
                </Grid>
              ))} */}
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button>Cancel</Button>
        <Button type="submit" variant="contained">
          Vincular Produtos
        </Button>
      </DialogActions>
    </Dialog>
  )
}